import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { transientOptions } from '../../constants/transientOptions'
import { Color } from '../../enums/color'
import { Asable } from '../../types/asable'
import { ColorVariant } from './types/colorVariant'

interface LinkProps extends Asable {
  colorVariant?: ColorVariant
  $disabled?: boolean
  underlined?: boolean
  withAnimation?: boolean
}

export const Link = styled('a', transientOptions)<LinkProps>`
  display: inline;
  background-image: linear-gradient(transparent 50%, ${Color.Lavender300} 0%);
  background-size: auto 200%;
  color: ${({ colorVariant }) => (colorVariant === 'highlight' ? Color.Lavender600 : 'currentColor')};
  font: inherit;
  text-decoration: ${({ underlined }) => (underlined ? 'underline' : 'none')};
  cursor: pointer;
  transition: background 0.14s ease-in-out;

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      text-decoration: none;
      cursor: not-allowed;
    `}

  ${({ withAnimation }) =>
    withAnimation &&
    css`
      &:hover {
        background-position-y: 100%;
        text-decoration: none;
      }
    `}
`
